import {
  CustomerActivityDto,
  MemberActivityDto,
  OrganisationActivityDto,
  EventsPerDayDto,
  MemoResponseDto,
  AverageDaysBetweenPostsDto,
  OrganisationPositionedListItem,
} from '@careapp-group/ng-sdk-v2-new';
import { Action, createAction, props } from '@ngrx/store';

export const REQUEST_ORGANISATION_ACTIVITY = '[Request][Statistics] Organisation activity';
export const RESPONSE_SUCCESS_ORGANISATION_ACTIVITY =
  '[Response][Success][Statistics] Organisation activity';
export const RESPONSE_FAIL_ORGANISATION_ACTIVITY =
  '[Response][Fail][Statistics] Organisation activity';

export const REQUEST_ORGANISATION_CONTENT_COUNT_PER_DAY =
  '[Request][Statistics] Organisation content count per day';
export const RESPONSE_SUCCESS_ORGANISATION_CONTENT_COUNT_PER_DAY =
  '[Response][Success][Statistics] Organisation content count per day';
export const RESPONSE_FAIL_ORGANISATION_CONTENT_COUNT_PER_DAY =
  '[Response][Fail][Statistics] Organisation content count per day';

export const REQUEST_ORGANISATION_DAYS_BETWEEN_CONTENT =
  '[Request][Statistics] Organisation days between content';
export const RESPONSE_SUCCESS_ORGANISATION_DAYS_BETWEEN_CONTENT =
  '[Response][Success][Statistics] Organisation days between content';
export const RESPONSE_FAIL_ORGANISATION_DAYS_BETWEEN_CONTENT =
  '[Response][Fail][Statistics] Organisation days between content';

export const REQUEST_MEMBERS_STATISTICS = '[Request][Statistics] members stats';
export const RESPONSE_SUCCESS_MEMBERS_STATISTICS = '[Response][Success][Statistics] members stats';
export const RESPONSE_FAIL_MEMBERS_STATISTICS = '[Response][Fail][Statistics] members stats';

export const REQUEST_CUSTOMERS_STATISTICS = '[Request][Statistics] customers stats';
export const RESPONSE_SUCCESS_CUSTOMERS_STATISTICS =
  '[Response][Success][Statistics] customers stats';
export const RESPONSE_FAIL_CUSTOMERS_STATISTICS = '[Response][Fail][Statistics] customers stats';

export const SET_DATE_RANGE = '[Statistics] Set Date Range';

export const SetDateRangeAction = createAction(
  SET_DATE_RANGE,
  props<{ earliest: Date; latest: Date }>()
);

export const RequestOrganisationActivityAction = createAction(
  REQUEST_ORGANISATION_ACTIVITY,
  props<{
    includePrevious?: boolean;
    // To request for all organisations in the store (admin only)
    useAllOrganisations?: boolean;
  }>()
);

export const ResponseSuccessOrganisationActivityAction = createAction(
  RESPONSE_SUCCESS_ORGANISATION_ACTIVITY,
  props<{
    current: { [id: string]: OrganisationActivityDto };
    previous?: { [id: string]: OrganisationActivityDto };
  }>()
);

export const ResponseFailOrganisationActivityAction = createAction(
  RESPONSE_FAIL_ORGANISATION_ACTIVITY,
  props<{ error: any }>()
);

export const ResponseSuccessOrganisationContentCountPerDayAction = createAction(
  RESPONSE_SUCCESS_ORGANISATION_CONTENT_COUNT_PER_DAY,
  props<{
    current: EventsPerDayDto[];
    previous?: EventsPerDayDto[];
  }>()
);

export const ResponseFailOrganisationContentCountPerDayAction = createAction(
  RESPONSE_FAIL_ORGANISATION_CONTENT_COUNT_PER_DAY,
  props<{ error: any }>()
);

export const ResponseSuccessOrganisationDaysBetweenContentAction = createAction(
  RESPONSE_SUCCESS_ORGANISATION_DAYS_BETWEEN_CONTENT,
  props<{
    current: AverageDaysBetweenPostsDto[];
    previous?: AverageDaysBetweenPostsDto[];
  }>()
);

export const ResponseFailOrganisationDaysBetweenContentAction = createAction(
  RESPONSE_FAIL_ORGANISATION_DAYS_BETWEEN_CONTENT,
  props<{ error: any }>()
);

export const RequestMembersStatisticsAction = createAction(REQUEST_MEMBERS_STATISTICS);

export const ResponseSuccessMembersStatisticsAction = createAction(
  RESPONSE_SUCCESS_MEMBERS_STATISTICS,
  props<{ payload: MemberActivityDto[] }>()
);

export const ResponseFailMembersStatisticsAction = createAction(
  RESPONSE_FAIL_MEMBERS_STATISTICS,
  props<{ error: any }>()
);

export const RequestCustomersStatisticsAction = createAction(REQUEST_CUSTOMERS_STATISTICS);

export const ResponseSuccessCustomersStatisticsAction = createAction(
  RESPONSE_SUCCESS_CUSTOMERS_STATISTICS,
  props<{ payload: CustomerActivityDto[] }>()
);

export const ResponseFailCustomersStatisticsAction = createAction(
  RESPONSE_FAIL_CUSTOMERS_STATISTICS,
  props<{ error: any }>()
);
/**
 * Fetch the count of organisation content for:
 * - The current organisation (if an org ID is currently selected)
 * - All organisations in the current tenant (when no org ID is selected)
 */
export const RequestOrganisationContentCountPerDay = createAction(
  '[Request][Statistics] org content count for org/tenant',
  props<{
    // To request for all organisations in the store (admin only)
    useAllOrganisations?: boolean;
  }>()
);
/**
 * Fetch the count of days between content for:
 * - The current organisation, or
 * - All organisations in the current tenant (when no org ID is selected)
 */
export const RequestOrganisationDaysBetweenContent = createAction(
  '[Request][Statistics] days between content for org/tenant',
  props<{
    // To request for all organisations in the store (admin only)
    useAllOrganisations?: boolean;
  }>()
);

export const RequestOrganisationEngagement = createAction(
  '[Request][Statistics] org engagement for selected org/tenant',
  props<{
    // To request for all organisations in the store (admin only)
    useAllOrganisations?: boolean;
  }>()
);
export const ResponseSuccessEngagement = createAction(
  '[Response][Success][Statistics] org engagement',
  props<{
    data: EventsPerDayDto[];
  }>()
);

export const ResponseFailEngagement = createAction(
  '[Response][Fail][Statistics] org engagement',
  props<{ error: any }>()
);

export const RequestFamilyLeaderboardAction = createAction(
  '[Request][Statistics] Family Leaderboard'
);

export const ResponseSuccessFamilyLeaderboardAction = createAction(
  '[Response][Success][Statistics] Family Leaderboard',
  props<{ current: MemberActivityDto[]; previous: MemberActivityDto[] }>()
);

export const ResponseFailFamilyLeaderboardAction = createAction(
  '[Response][Fail][Statistics] Family Leaderboard',
  props<{ error: any }>()
);

export const RequestMostActiveOrganisationsForTenant = createAction(
  '[Request][Statistics] Most active organisations in tenant'
);

export const ResponseSuccessMostActiveOrganisationsForTenant = createAction(
  '[Response][Success][Statistics] Most active organisations in tenant',
  props<{ current: OrganisationPositionedListItem[]; previous: OrganisationPositionedListItem[] }>()
);

export const ResponseFailMostActiveOrganisationsForTenant = createAction(
  '[Response][Fail][Statistics] Most active organisations in tenant',
  props<{ error: any }>()
);

export const RequestMostConnectedOrganisationsForTenant = createAction(
  '[Request][Statistics] Most connected organisations in tenant'
);

export const ResponseSuccessMostConnectedOrganisationsForTenant = createAction(
  '[Response][Success][Statistics] Most connected organisations in tenant',
  props<{ current: OrganisationPositionedListItem[]; previous: OrganisationPositionedListItem[] }>()
);

export const ResponseFailMostConnectedOrganisationsForTenant = createAction(
  '[Response][Fail][Statistics] Most connected organisations in tenant',
  props<{ error: any }>()
);

export const RequestTopMoments = createAction(
  '[Request][Statistics] Top Moments For Selected Tenant/Organisation'
);

export const ResponseFailTopMoments = createAction(
  '[Response][Fail][Statistics] top moments',
  props<{ error: any }>()
);
export const RequestCustomersStatisticsForTenantAction = createAction(
  `${REQUEST_CUSTOMERS_STATISTICS} for tenant`
);

export const RequestMemberStatisticsForTenantAction = createAction(
  `${REQUEST_MEMBERS_STATISTICS} for tenant`
);
